import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";

import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkText } from "uitk-react-text";

import { Hotel } from "typings/microserviceModels/hotels-flex-module";

const FeaturedReview = (props: { hotel: Hotel; className: string }) => {
  const { hotel, className } = props;
  const { featuredReviews } = hotel;
  const featuredReview = featuredReviews?.[0];

  if (!featuredReview) {
    return null;
  }

  const { formatText } = useLocalization();

  return (
    <UitkLayoutFlex direction="column" className={className}>
      <UitkText overflow="truncate-3-lines" size={300} className="all-b-margin-three">
        {`\u0022${featuredReview.review}\u0022`}
      </UitkText>
      <UitkText size={200}>{formatText("hotels.review.reviewedOn", featuredReview.reviewDate)}</UitkText>
    </UitkLayoutFlex>
  );
};

export default FeaturedReview;
